class ComponentFaqSidebar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      this.targetFaq = this.querySelector('[data-faq-content-target]');
      this.contentFaq = [...document.querySelectorAll('[data-faq-content]')];
      
      this.targetContact = this.querySelector('[data-faq-contact-target]');
      this.contentContact = document.querySelector('[data-faq-contact-content]');
      
      if (this.targetFaq && this.contentFaq) {
        let html = '';
        this.contentFaq.forEach((element) => {
          html += element.innerHTML;
        })

        this.targetFaq.innerHTML = html;
      }

      if (this.targetContact && this.contentContact) {
        this.targetContact.innerHTML = this.contentContact.innerHTML;
      }
    }, 500)

  }
}

if (!customElements.get("component-faq-sidebar")) {
  customElements.define("component-faq-sidebar", ComponentFaqSidebar);
}
